import React from "react";
const InputField = ({
  label,
  type,
  name,
  size,
  placeholder,
  required,
  value,
  onChange,
  disabled,
  checked,
  icon,
  options = [], // ADD THIS
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange("input", name, value); // Call the parent's update function
  };

  return (
    <div className={"col-lg-" + size}>
      {type === "checkbox" || type === "radio" ? (
        <>
          <label className="ui-checkbox ui-checkbox-info">
            <input
              required={required}
              className="form-check-input"
              type="checkbox"
              id={name}
              name={name}
              value={value}
              checked={checked}
              onChange={handleChange}
            />
            <span className="input-span"></span>
            {label}
          </label>
        </>
      ) : (
        <>
          <div className="form-group mt-2 p-0">
            <label htmlFor={name} className="col-sm-12 p-0">
              <i className={icon} style={{ fontSize: "20px" }} />
              <i /> {label}:{/* Page Layout */}
            </label>
            <div className="col-sm-12 p-0">
              <input
                list={`${name}-list`}
                id={name}
                disabled={disabled}
                className="form-control"
                required={required}
                type={type}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
              />
              {options.length > 0 && (
                <datalist id={`${name}-list`}>
                  {options.map((option, index) => (
                    <option key={index} value={option} />
                  ))}
                </datalist>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InputField;
